import {
	Component,
	Input,
	Output,
	EventEmitter
} from '@angular/core';

@Component({
	selector: 'sm-number-range',
	template: require('./sm-number-range.component.html')
})
export class SmNumberRangeComponent {
	@Input() label: string = '';
	@Input('start') start: number;
	@Input('end') end: number;
	@Output('onChange') onChange: EventEmitter<NumberRangeModel> = new EventEmitter();

	startChanged(start: number) {
		this.start = start;
		this._fireOnChange();
	}

	endChanged(end: number) {
		this.end = end;
		this._fireOnChange();
	}

	private _fireOnChange() {
		if (this.onChange) {
			this.onChange.emit({
				start: this.start,
				end: this.end
			});
		}
	}
}

export interface NumberRangeModel {
	start: number;
	end: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-number-range.component.ts